// What ProtectedRoute (App.jsx) does with the auth state it reads. Pure, so
// every combination can be tested. Same behaviour as the guard always had:
// no session goes to "/", a subscription route lets in a truthy
// hasActiveSubscription (or the localhost dev bypass), an expired promo trial
// goes back through onboarding once, and every other unpaid account gets the
// paywall.
//
// The paywall, not onboarding, on purpose: a payer coming back from checkout
// (Success.jsx, FbSuccess) may have an account created server side without
// onboarding_completed, and must land on the paywall with its restore button,
// not in the onboarding funnel. Only the login redirects (getPostLoginRoute)
// send a not-onboarded account to onboarding.
import { ONBOARDING_ROUTE } from '@/lib/landingRoute';

export const PRICING_ROUTE = '/pricing';

const SPINNER = { kind: 'spinner' };
const ALLOW = { kind: 'allow' };
const redirect = (to) => ({ kind: 'redirect', to });

/**
 * @returns {{kind:'spinner'}|{kind:'allow'}|{kind:'redirect',to:string}}
 */
export function decideGuard(input) {
  const s = input !== null && typeof input === 'object' && !Array.isArray(input) ? input : {};
  const {
    loading = false,
    user = null,
    isDev = false,
    requireSubscription = false,
    subscriptionLoading = false,
    hasActiveSubscription = false,
    hadExpiredPromoTrial = false,
  } = s;

  if (loading || (requireSubscription && subscriptionLoading)) return SPINNER;
  if (!user && !isDev) return redirect('/');
  if (!requireSubscription || hasActiveSubscription || isDev) return ALLOW;
  if (hadExpiredPromoTrial) return redirect(ONBOARDING_ROUTE);
  return redirect(PRICING_ROUTE);
}
